import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
import appSettings from '../../appSettings';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appSettings.APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    disableAjaxTracking: true,
    disableFetchTracking:true,
    autoTrackPageVisitTime: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
  }
});
appInsights.loadAppInsights();

function logInfo(severity, component, url) {
  reactPlugin.trackEvent({
    name: "AGSS Service Call " + component,      
    properties: {
      'am-severity': severity,
      'am-component': component,
      'am-url': url
    },
  });
}

function logError(error, severity, errorComponent) {
  const errorMessage = error.message || error;
  const errorStack = error.stack || error;
  reactPlugin.trackException(
    { exception: error, 
      severityLevel: severity}, 
    {'am-message': errorMessage,
    'am-error': errorStack,
    'am-component': errorComponent});
}

export { reactPlugin, appInsights, logInfo, logError};